'use client';

import FormError from '@/components/FormError';
import { useIsMobile } from '@/hooks/use-is-mobile';
import { useWarrantyPage } from '@/hooks/WarrantyPage/useWarrantyPage';
import { Button, Form, Input } from 'antd';
import classes from './warrantyPage.module.css';

const validateMessages = {
  required: '${label} is required!',
  types: {
    email: '${label} is not a valid email!',
    number: '${label} is not a valid number!',
  },
  number: {
    range: '${label} must be between ${min} and ${max}',
  },
};

export const WarrantyForm = () => {
  const talonProps = useWarrantyPage({});

  const { isLoading, handleSubmit, response, formErrors } = talonProps;

  const { isMobile } = useIsMobile();

  const maybeSuccessInfo =
    response && response.code === '200' ? (
      <p className={classes.successInfo}>
        We have received your application and will get back to you via email within 72 hours!
      </p>
    ) : null;

  const buttonText = isLoading ? 'Sending...' : 'Send';

  return (
    <Form
      layout={!isMobile ? 'vertical' : null}
      onFinish={handleSubmit}
      className={classes.form}
      name='nest-messages'
      validateMessages={validateMessages}
    >
      <Form.Item
        label='Email'
        id='drip-email'
        name={'email'}
        normalize={value => (typeof value === 'string' ? value.trim() : '')}
        rules={[
          {
            required: true,
            type: 'email',
          },
        ]}
      >
        <Input />
      </Form.Item>
      <div className='flex grid-cols-2 flex-col lg_grid lg_gap-[20px]'>
        <Form.Item
          name={'firstname'}
          label='First Name'
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name={'lastname'}
          label='Last Name'
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
      </div>

      <Form.Item
        name={'increment_id'}
        label='Order Number'
        rules={[
          {
            required: true,
          },
          {
            type: 'string',
            pattern: /^\d{3}-\d{7}-\d{7}|KY\d{9}|\d{15}/i,
            min: 11,
            max: 19,
            message: 'Order Number is not a valid order number!',
          },
        ]}
        className={classes.ordernumber}
      >
        <Input />
      </Form.Item>
      <p className={classes.tips}>
        Amazon orders are 19 digits long with two dashes, with the following format (as an example, your order number
        will be different): 103-4795772-1364518
      </p>
      <Form.Item>
        <Button
          type='primary'
          disabled={isLoading}
          htmlType='submit'
          className={classes.submitButton}
        >
          {buttonText}
        </Button>
      </Form.Item>
      <FormError errors={formErrors} />
      {maybeSuccessInfo}
    </Form>
  );
};

export default WarrantyForm;
